import { post, get } from "shared-utils";
import type { AdditionalCostsData } from "@wayflyer/flyui-dataviz";
import { useLocalStorage } from "shared-ui";

import { reportRequestFailure } from "./report-request-failure";

const ADDITIONAL_COSTS_KEY = "wayflyer-insights-additional-cost-data-";

export const initialAdditionalCosts: AdditionalCostsData = {
  cogs: 0,
  shipping: 0,
  opex: 0,
  marketing: 0,
};

const storeAdditionalCostsDataInLocalStorage = (additionalCostsPath, additionalCostsData: AdditionalCostsData) => {
  window.localStorage.setItem(ADDITIONAL_COSTS_KEY + additionalCostsPath, JSON.stringify(additionalCostsData));
};

export function getAdditionalCostsData(
  additionalCostsPath: string,
  onSuccess: (data: AdditionalCostsData) => any,
  onFailure: (failureMessage: string) => any
) {
  get(
    additionalCostsPath,
    (data: AdditionalCostsData) => {
      onSuccess(data);
    },
    (failureMessage: string, isNetworkFailure: boolean) => {
      reportRequestFailure("Error fetching additional costs data", failureMessage, isNetworkFailure);
      onFailure(failureMessage);
    }
  );
}

export function storeAdditionalCostsData(
  additionalCostsPath: string,
  additionalCostsData: AdditionalCostsData,
  onSuccess: () => any,
  onFailure: (failureMessage: string) => any
) {
  post(
    additionalCostsPath,
    {
      additionalCosts: additionalCostsData,
    },
    onSuccess,
    (failureMessage, isNetworkFailure) => {
      reportRequestFailure("Error updating additional costs data", failureMessage, isNetworkFailure);
      onFailure(failureMessage);
    }
  );
  storeAdditionalCostsDataInLocalStorage(additionalCostsPath, additionalCostsData);
}

export const useAdditionalCosts = (additionalCostsPath) => {
  return useLocalStorage(ADDITIONAL_COSTS_KEY + additionalCostsPath, initialAdditionalCosts, true);
};
